/** PKCE (RFC 7636) helpers for Google authorization-code sign-in. */

const BASE64_URL_CHARS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

const randomBase64Url = (byteLength: number): string => {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);

  let result = "";
  for (const byte of bytes) {
    result += BASE64_URL_CHARS[byte % BASE64_URL_CHARS.length];
  }
  return result;
};

/** High-entropy code verifier (43–128 chars per RFC 7636). */
export const generateCodeVerifier = (): string => randomBase64Url(64);

/** S256 code challenge derived from the verifier. */
export const generateCodeChallenge = async (
  verifier: string,
): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );

  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

/** Anti-CSRF state token round-tripped through the provider. */
export const generateState = (): string => randomBase64Url(32);

/** Replay-protection nonce echoed by Apple in the identity token. */
export const generateNonce = (): string => randomBase64Url(32);
